import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import HelpContent from './help-content/HelpContent';

const HelpContainer = ({ activated, triggerElement }) => {
  const popupContainer = document.getElementById('qau-help-container');
  const popupNode = document.createElement('div');
  const prevActivatedRef = useRef(activated);
  const triggerElementRef = useRef(null);

  useEffect(() => {
    if (triggerElement) {
      triggerElementRef.current = triggerElement;
    }

    if (prevActivatedRef.current && !activated) {
      const elementToFocus = triggerElementRef.current;
      if (elementToFocus && document.contains(elementToFocus)) {
        elementToFocus.focus();
      }
      triggerElementRef.current = null;
    }
    prevActivatedRef.current = activated;
  }, [activated, triggerElement]);

  useEffect(() => {
    if (activated) {
      popupContainer.appendChild(popupNode);
      popupContainer.setAttribute('class', 'active');
      return () => {
        popupContainer.removeChild(popupNode);
        popupContainer.removeAttribute('class');
      };
    }
  }, [activated, popupContainer, popupNode]);

  return activated ? createPortal(<HelpContent />, popupContainer) : null;
};

const mapStateToProps = ({ help }) => ({
  activated: help.activated,
  triggerElement: help.triggerElement,
});

HelpContainer.propTypes = {
  activated: PropTypes.bool.isRequired,
  triggerElement: PropTypes.instanceOf(Element),
};

export default connect(mapStateToProps)(HelpContainer);
